module.exports = __webpack_public_path__ + "static/media/nikita_tipule.50681c19.png";